import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { AlertCircle } from "lucide-react"
import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoginDialog } from "./loginDialog";

export const NoAuthError = () => {
    const location = useLocation();
    const [redirect, setRedirect] = useState(false);
    const handleCLick = () => {
        setRedirect(true);
    }
    return (
        <div className="flex m-auto py-4">
            <Alert variant="destructive">
                <AlertCircle className="w-4 h-4"/>
                <AlertTitle>Error</AlertTitle>
                <AlertDescription>
                    <div className="flex mt-4 flex-col gap-4">
                        No tienes acceso a esta página o tu sesión ha expirado
                        <LoginDialog/>
                    </div>                    
                </AlertDescription>
            </Alert>
            {(redirect)&&(<Navigate to="/login" state={{from:location}} />)}
        </div>
    )
}